import axios from '@shared/axios-shared';

export const getCameraList = (params) => {
	return axios.get(`/api/v2/owner/camera?${params}`);
};

export const updateCamera = (id, data) => {
	return axios.patch(`/api/v2/owner/camera/${id}`, data);
};

export const deleteCamera = (id) => {
	return axios.delete(`/api/v2/owner/camera/${id}`);
};

export const registerCamera = (data) => {
	return axios.post(`/api/v2/owner/camera`, data);
};
